<template lang="pug">
  .result-indicators(v-if="isFiltered && !loading")
    span(v-if="showAdvancedConversationFilter")
      | Showing
      span(v-if="visibleResults > 0")
        b.ml-5.mr-5 {{ 1 }}-{{ visibleResults }}
        | of
      b.ml-5.mr-5 {{ totalResults }}
      | results
    span(v-else)
      | Matched:
      b.mr-5 {{ totalResults }}
      | Showing:
      b 0 - {{ visibleResults }}
</template>

<script>
import { mapState } from 'vuex';
import isNil from 'lodash/isNil';
import assign from 'lodash/assign';

export default {
  name: 'ResultsIndicators',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      isFiltered: state => !isNil(state.conversations.filter),
      pagination: state => assign({ offset: 0, limit: 0, rowCount: 0 },
        state.conversations.pagination),
      showAdvancedConversationFilter: state =>
        state.featureFlags.FEATURE_FLAGS.SHOW_ADVANCED_CONVERSATION_FILTER,
    }),
    totalResults() {
      return this.pagination.rowCount;
    },
    visibleResults() {
      return Math.min(this.pagination.offset + this.pagination.limit, this.pagination.rowCount);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/aiq-variables.scss";

.result-indicators {
  text-align: center;
  font-size: 12px;
  font-weight: 300;
  color: #5e718a;
  background: $aiq-bgc-body;
  padding: 8px 16px 8px 16px;
}

.mr-5 {
  margin-right: 5px;
}
.ml-5 {
  margin-left: 5px;
}
</style>
